module.exports = __webpack_public_path__ + "static/media/edit-icon-blue.2ea5f3a4.svg";